import dailyCloseout from "@/api/credit-operation/daily-closeout";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    editData: null
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_EDIT_DATA(state, data) {
        state.editData = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage || 15,
                search: context.state.search
            },
            attributes
        );
        return dailyCloseout.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    show(context, id) {
        return dailyCloseout.show(id);
    },

    update(context, { id, data }) {
        return dailyCloseout.update(id, data);
    },

    destroy(context, { id, data }) {
        return dailyCloseout.destroy(id, data);
    },

    clearCash(context, payload = {}) {
        return dailyCloseout.clearCash(payload);
    },

    async fetchCreateResources(context, attributes = {}) {
        return dailyCloseout.createResources({
            params: attributes
        });
    },

    async fetchCoRepayments(context, attributes = {}) {
        return dailyCloseout.fetchCoRepayments({
            params: attributes
        });
    }
};
